export default function createOrganizationBlockReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_ORGANIZATION_BLOCK_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_ORGANIZATION_BLOCK_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_ORGANIZATION_BLOCK_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}